(ns app.front.view.group.admin.ai.configuration
  (:require [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]))

(defn section [tr]
  (let [auto-fill-disabled? (contains? (<sub [::gas/group-features])
                                       :group.feature/disable-ai-document-analysis)
        ai-tr               (i18n-model/wrap-tr-fn
                              {:group.feature.title/disable-ai-document-analysis :ai-settings/auto-fill-title
                               :group.feature/disable-ai-document-analysis       :ai-settings/auto-fill-help
                               :group.feature/disable-ai                         :ai-settings/nova-help
                               :yes                                              :ai-settings/enable
                               :no                                               :ai-settings/disable}
                              tr)
        ;; Stored disable-* keys use the opposite value from the displayed Enable/Disable choice.
        common-options      {:tr ai-tr :inverted? true}]
    [acommon/section
     {}
     (if (ff/enabled? :feature-flag.id/ai-settings-controls)
       [:<>
        (when (ff/enabled? :feature-flag.id/application-wizard)
          [:<>
           [feature-toggle/toggle-group-feature
            (assoc common-options :feature-name :group.feature/disable-ai-document-analysis)]
           [feature-toggle/toggle-group-feature
            (assoc common-options
                   :feature-name :group.feature/disable-ai-auto-fill-for-citizens
                   :disabled? auto-fill-disabled?
                   :disabled-reason (when auto-fill-disabled? (tr [:ai-settings/citizen-unavailable])))]
           [feature-toggle/toggle-group-feature
            (assoc common-options
                   :feature-name :group.feature/disable-plan-check
                   :feature-flag :feature-flag.id/wizard-ai-precheck)]])
        [feature-toggle/toggle-group-feature
         (assoc common-options
                :feature-name :group.feature/disable-ai
                :feature-flag :feature-flag.id/ai-chat)]]
       [feature-toggle/toggle-group-feature
        (util/mmap {:feature-name :group.feature/disable-ai-document-analysis
                    :feature-flag :feature-flag.id/application-wizard}
                   tr)])]))
